import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';

export default class InfoBox extends React.Component {

  calculateWidth = () => {
    let width = 0;
    if( this.props.screenWidth < 1030 || this.props.screenWidth >= 1030 ) {
      width = 400;
    }
    if( this.props.screenWidth < 700 ) {
      width = 400;
    }
    if( this.props.screenWidth <= 400 ) {
      width = 390;
    }
    if( this.props.screenWidth < 360 ) {
      width = 320;
    }
    return width;
  }

  render() {

    let width = this.calculateWidth();

    return (
      <div className={"modal-content info-box"}>
        <div className={'modal-content-responsive-container'} style={{ width: width, height: this.props.screenHeight * .75}}>

          <Scrollbars style={{ width: width, height: this.props.screenHeight * .75 }}>

            <div className={"modal-scrollable-content"}>
          <h1>Hi!</h1>

          <p>If you are here to experience the awe and wonder that is <a href="https://mysteriouspackage.com/products/taako?utm_source=website&utm_medium=button&utm_campaign=farspeech">Taako’s Correspondence School of Wizardry, Cantrips, & Other Magicks</a>, you have come to the right place!</p>

           <p>If you have stumbled here by accident, the short explanation of this site is that world
             famous wizard and television personality Taako has offered his Wizardly experience via
             correspondence to only the most special and valued people who have been willing to
             invest in themselves!</p>

          <p>For the best experience be sure to:</p>
          <ul>
            <li>Turn your speakers up.</li>
            <li>Have your Correspondence School Activities at hand.</li>
            <li>Dress in a way that feels wizard-like to you.</li>
          </ul>

          <h4>Hints:</h4>
          <p>For the overachievers in the group, there is a set of hints available to <a href="/taako-hints.pdf">download</a>.</p>


          <p><small>Copyright © 2018 by The Mysterious Package Company Inc.</small></p>
          <p><small>All rights reserved. Any redistribution or reproduction of part or
            all of the contents in any form is prohibited. All Trademarks
            mentioned herein belong to their respective owners.</small></p>
            </div>

        </Scrollbars>
        </div>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/InfoBox.js